import { Figure } from "components/Figure";
import { SrcSet } from "components/SrcSet";

export const ImageWrapper = ({ primary }) => {
  const { caption, image } = primary;
  return <Image alt={image.alt} src={image.url} caption={caption} />;
};

export const Image = ({ alt, caption, src }) => (
  <Figure caption={caption}>
    <SrcSet alt={alt} src={src} />
  </Figure>
);
